import Vue from 'vue';
import Router from 'vue-router';
// import {ConstStatic} from './../core/constStatic';
Vue.use(Router);

// function loadView(view) {
//   return () => import(`../pages${view}.vue`);
// }

const router = new Router({
    mode: 'history',
    base:'player',
    routes: [
        {
            // 暂无主页 用video代替
            path: '/',
            name: 'video',
            component: () => import(`../pages/video/index.vue`)
        },
        {
            path: '/video',
            name: 'video',
            component: () => import(`../pages/video/index.vue`)
        },
    ],

});
export default router;